import {AppState} from '../../index';

export const dobroruLinkSelector = (state: AppState) => state.dobroru.link;

export const dobroruDataSelector = (state: AppState) => state.dobroru.data;

export const dobroruDataLoadingSelector = (state: AppState) => state.dobroru.dataLoading;
